import { render } from "./GradientBackground.vue?vue&type=template&id=4f46d80e&scoped=true"
import script from "./GradientBackground.vue?vue&type=script&lang=js"
export * from "./GradientBackground.vue?vue&type=script&lang=js"

import "./GradientBackground.vue?vue&type=style&index=0&id=4f46d80e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f46d80e"]])

export default __exports__